import config from "@/config";
import { requests } from ".";

const ASSOCIATIONS_SERVER_URL =
  config?.ASSOCIATIONS_SERVER_URL || "https://staging.services.leadconnectorhq.com";

export const AssociationService = {
  /**
   * Get associations for a custom object with contacts
   * @param objectKey - The custom object key (e.g., "custom_objects.doctors")
   * @param locationId - The location ID
   * @param withObjectKey - The object to associate with (default: "contact")
   */
  getAssociations: (objectKey: string, locationId: string, withObjectKey = "contact") =>
    requests(ASSOCIATIONS_SERVER_URL).get(
      `/associations/objectKey/${objectKey}?withObjectKey=${withObjectKey}&locationId=${locationId}`
    ),
};
